
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext } from "vue";
export default defineComponent({
  name: "BannerItem",
  props: {
    /**
     * 画像URL
     */
    imageUrl: {
      type: String,
      required: true
    },
    /**
     * 検索タグ種別
     */
    id: {
      type: Number,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const onClick = () => {
      NativeClient.sendDebugLog("BannerItem onClick props.id=" + props.id);
      context.emit("on-click", props.id);
    };
    const onError = (event: Event) =>{
      if (event.target) {
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
      }
    };
    return {
      onClick,
      onError
    };
  }
});
